export default class ShippingForm {

    constructor() {
        this.serbiaState = 'RS';
    }

    init() {
        if ($('#shipping_country').length > 0) {
            this.generateBillingCity();
            let self = this;
            $('#shipping_country').on('change', function () {
                self.generateBillingCity();
            });
        }
    }

    generateBillingCity() {

        let self = this;

        if (this.serbiaState === $('#shipping_country').val()) {
            fetch(apiUrl + '/checkout_form/billing_cities')
                .then(response => response.json())
                .then(data => {
                    let cities = Object.values(data.data);
                    self.setBillingCitySelect(cities);
                })
        } else {
            self.setBillingCityInput();
            self.setBillingPostcodeInput();
        }
    }

    generateBillingPostcode() {

        let self = this;
        if (this.serbiaState === $('#shipping_country').val()) {
            let cityId = $('#shipping_city').find(':selected').attr('data-city');

            fetch(apiUrl + '/checkout_form/billing_postcode?city_id=' + cityId)
                .then(response => response.json())
                .then(data => {
                    let postcode = Object.values(data.data);

                    self.setBillingPostcodeSelect(postcode);
                })
        } else {
            self.setBillingCityInput();
            self.setBillingPostcodeInput();
        }
    }

    setBillingCityInput() {
        $('#shipping_city').off('change');
        $('#shipping_city').replaceWith('<input type="text" class="input-text " name="shipping_city" id="shipping_city" placeholder="">');
        $('#hidden_shipping_city').remove();
    }

    getCookie(name) {
        let pattern = RegExp(name + "=.[^;]*")
        let matched = document.cookie.match(pattern)
        if (matched) {
            let cookie = matched[0].split('=')
            return cookie[1]
        }
        return 'Default';
    }

    setBillingCitySelect(cities) {

        let cookieValue = this.getCookie('CyrLatConverterSelected');

        let label = cookieValue == 'Default' ? 'Изаберите општину:' : 'Izaberite opštinu';

        let citiesHTML = '<option selected value="">' + label + ':</option>';
        cities.forEach(function (item, index) {
            citiesHTML += `<option value="${item.name}" data-city="${item.city_id}">${item.name}</option>`
        })

        let self = this;
        $('#shipping_city').replaceWith(`<select id="shipping_city">${citiesHTML}</select><input type="hidden" name="shipping_city" id="hidden_shipping_city">`);

        $('#shipping_city').on('change', function () {
            self.generateBillingPostcode();
        });
    }

    setBillingPostcodeInput() {
        $('#shipping_postcode').replaceWith('<input type="text" class="input-text " name="shipping_postcode" id="shipping_postcode" placeholder="">');
    }

    setBillingPostcodeSelect(postcode) {
        let cookieValue = this.getCookie('CyrLatConverterSelected');

        let label = cookieValue == 'Default' ? 'Изаберите поштански број и место:' : 'Izaberite poštanski broj i mesto';

        let potcodeHTML = '<option selected value=""> ' + label + ':</option>';
        postcode.forEach(function (item, index) {
            potcodeHTML += `<option value="${item.ptt}" data-shipping_city="${item.name}">${item.name} - ${item.ptt}</option>`
        })

        $('#shipping_postcode').replaceWith(`<select id="shipping_postcode" name="shipping_postcode">${potcodeHTML}</select>`);

        $('#shipping_postcode').on('change', function () {
            document.getElementsByName('shipping_city')[0].value = $('#shipping_postcode').find(':selected').attr('data-shipping_city');
        });
    }

}



// WEBPACK FOOTER //
// ./static/js/components/ShippingForm.js